import type { Template } from "@/types";

export const PO_05_H1_V4: Template[] = [
    {
        id: "po-05-h1v4-01",
        name: "PO 01 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 45, y: 231, width: 560, height: 364, rotation: 0, imageRotation: 0 },
            { id: "2", x: 789, y: 151, width: 181, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 789, y: 418, width: 181, height: 258, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 151, width: 181, height: 259, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 418, width: 181, height: 258, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-02",
        name: "PO 02 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 45, y: 231, width: 560, height: 364, rotation: 0, imageRotation: 0 },
            { id: "2", x: 701, y: 112, width: 398, height: 603, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1107, y: 112, width: 138, height: 196, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1107, y: 316, width: 138, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1107, y: 520, width: 138, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-03",
        name: "PO 03 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 62, y: 118, width: 524, height: 331, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 62, y: 457, width: 170, height: 252, rotation: 0, imageRotation: 0 },
            { id: "3", x: 240, y: 457, width: 169, height: 252, rotation: 0, imageRotation: 0 },
            { id: "4", x: 417, y: 457, width: 169, height: 252, rotation: 0, imageRotation: 0 },
            { id: "5", x: 741, y: 92, width: 463, height: 631, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-04",
        name: "PO 04 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 56, y: 183, width: 294, height: 463, rotation: 0, imageRotation: 0 },
            { id: "2", x: 358, y: 183, width: 236, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 341, width: 236, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 712, y: 228, width: 256, height: 370, rotation: 0, imageRotation: 0 },
            { id: "5", x: 976, y: 228, width: 256, height: 370, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-05",
        name: "PO 05 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 66, y: 228, width: 256, height: 370, rotation: 0, imageRotation: 0 },
            { id: "2", x: 330, y: 228, width: 256, height: 370, rotation: 0, imageRotation: 0 },
            { id: "3", x: 704, y: 183, width: 294, height: 463, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1006, y: 183, width: 236, height: 305, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1006, y: 496, width: 236, height: 150, rotation: 0, imageRotation: 0 }          
        ],
    },

    {
        id: "po-05-h1v4-06",
        name: "PO 06 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 101, y: 97, width: 446, height: 632, rotation: 0, imageRotation: 0 },
            { id: "2", x: 704, y: 372, width: 538, height: 334, rotation: 0, imageRotation: 0 },
            { id: "3", x: 704, y: 121, width: 175, height: 243, rotation: 0, imageRotation: 0 },
            { id: "4", x: 887, y: 121, width: 174, height: 243, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1069, y: 121, width: 174, height: 243, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-07",
        name: "PO 07 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_07.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 30, y: 136, width: 185, height: 273, rotation: 0, imageRotation: 0 },
            { id: "2", x: 30, y: 417, width: 185, height: 272, rotation: 0, imageRotation: 0 },
            { id: "3", x: 223, y: 136, width: 185, height: 273, rotation: 0, imageRotation: 0 },
            { id: "4", x: 223, y: 417, width: 185, height: 272, rotation: 0, imageRotation: 0 },
            { id: "5", x: 416, y: 136, width: 851, height: 553, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-08",
        name: "PO 08 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 219, width: 615, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 623, y: 219, width: 263, height: 390, rotation: 0, imageRotation: 0 },        
            { id: "3", x: 894, y: 219, width: 133, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 894, y: 418, width: 133, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1035, y: 219, width: 263, height: 390, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-09",
        name: "PO 09 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 219, width: 615, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 623, y: 219, width: 263, height: 390, rotation: 0, imageRotation: 0 },
            { id: "3", x: 894, y: 219, width: 263, height: 390, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1165, y: 219, width: 133, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1165, y: 418, width: 133, height: 191, rotation: 0, imageRotation: 0 }
        ],
    }
];